import { Alert, Drawer, Select, Table } from '@pankod/refine-antd'
import {
  useCustomMutation,
  useInvalidate,
  useResource,
} from '@pankod/refine-core'
import React from 'react'

import {
  PROGRAM_LOCAL_STATE,
  PROGRAM_LOCAL_STATE_LABEL,
  TLMSProgramLocal,
} from '@resources/lms-management/program-lokal/types'
import useTableWithMeta from 'src/hooks/useTableWithMeta'
import { TCommonError } from 'src/interfaces/common'
import { showErrorNotification } from '@resources/angkatan-ppg-management/utils'

type UpdateProgramLocalDrawerProps = {
  visible: boolean
  onClose: () => void
}

const UpdateProgramLocalDrawer = ({
  onClose,
  visible,
}: UpdateProgramLocalDrawerProps) => {
  const { id } = useResource()
  const invalidate = useInvalidate()
  const resource = `programs/${id}/local-programs`
  const { tableProps, tableQueryResult } = useTableWithMeta<
    TLMSProgramLocal,
    TCommonError
  >({
    dataProviderName: 'lms',
    resource,
    queryOptions: {
      enabled: visible,
    },
  })

  const { mutateAsync, isLoading } = useCustomMutation()

  const handleUpdateStatus = async (
    programLocalId: string | number,
    status: PROGRAM_LOCAL_STATE,
  ) => {
    await mutateAsync({
      dataProviderName: 'lms',
      method: 'post',
      url: `${process.env.NEXT_PUBLIC_LMS_API_URL}/ops-tools/alter-program-participants/program-local`,
      values: {
        programId: id,
        programLocalId,
        programLocalStatus: status,
      },
      successNotification: {
        message: 'Status program lokal berhasil diubah',
        type: 'success',
        description: 'Sukses',
      },
      errorNotification: (e) =>
        showErrorNotification(
          e,
          'Terdapat gangguan saat ubah status program lokal',
        ),
    })
    invalidate({ resource, dataProviderName: 'lms', invalidates: ['list'] })
  }

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title="Ubah Program Lokal"
      size="large"
    >
      <Alert
        type="warning"
        showIcon
        message={
          <>
            Perubahan status akan <strong>langsung diterapkan</strong> ketika
            status program lokal diubah.
          </>
        }
        className="!mb-4"
      />
      <Table
        {...tableProps}
        rowKey={'id'}
        size="small"
        loading={tableQueryResult.isFetching || isLoading}
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
          },
          {
            title: 'Nama Program Lokal',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: 'Status',
            width: 120,
            render: (_, record) => (
              <Select
                value={record.status}
                className="!w-full"
                disabled={isLoading}
                options={Object.entries(PROGRAM_LOCAL_STATE_LABEL).map(
                  ([value, label]) => ({
                    label,
                    value,
                  }),
                )}
                onChange={(value) => handleUpdateStatus(record.id, value)}
              />
            ),
          },
        ]}
      />
    </Drawer>
  )
}

export default UpdateProgramLocalDrawer
